// Main entry — the production View and its hook. Sim wrappers live under
// ./sim and are never imported here, so a production import can't pull in
// fixtures.
export { ResponsiveAddress } from "./ResponsiveAddress";
export type { ResponsiveAddressProps } from "./ResponsiveAddress";
export { useResponsiveAddress } from "./useResponsiveAddress";
export type { UseResponsiveAddressOptions } from "./useResponsiveAddress";
export { ADDRESS_TIERS, formatAddressTier, pickAddressTier } from "./addressTiers";
export type { AddressTier, PickAddressTierOptions } from "./addressTiers";
